<template>
	<v-dialog :value="dialog" max-width="60%" @input="changeDialog">
		<v-card>
			<v-card-title>
				<span class="text-h5">Análise de causa e efeito</span>
			</v-card-title>
			<v-card-text>
				<v-container>
					<v-row>
						<v-col cols="12">
							<v-textarea
								v-model="causeEffectAnalysis.PROBRE"
								label="Problema a ser resolvido"
								rows="4"
							></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="causeEffectAnalysis.ANAMQU"
								label="Análise Máquina"
								rows="4"
							></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="causeEffectAnalysis.ANAMAT"
								label="Análise Materiais"
								rows="4"
							></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="causeEffectAnalysis.MAOOBR"
								label="Mão de Obra"
								rows="4"
							></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="causeEffectAnalysis.MEIAMB"
								label="Meio Ambiente"
								rows="4"
							></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="causeEffectAnalysis.ANAMET"
								label="Análise Método"
								rows="4"
							></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="causeEffectAnalysis.MEDIDA"
								label="Medidas"
								rows="4"
							></v-textarea>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" text :disabled="loading" @click="close">
					Fechar
				</v-btn>
				<v-btn color="blue darken-1" text :loading="loading" @click="save">
					Salvar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "CauseEffectAnalysis",
	props: {
		dialog: { type: Boolean, value: false },
		causeEffectAnalysis: { type: Object, required: true, value: {} },
		loading: { type: Boolean, value: false },
	},
	methods: {
		changeDialog(value) {
			if (!value) {
				this.close();
			}
		},
		close() {
			this.$emit("close");
		},
		save() {
			this.$emit("save", this.causeEffectAnalysis);
		},
	},
};
</script>
